import { render, staticRenderFns } from "./LangButton.vue?vue&type=template&id=40098b80&scoped=true&"
import script from "./LangButton.vue?vue&type=script&lang=js&"
export * from "./LangButton.vue?vue&type=script&lang=js&"
import style0 from "./LangButton.vue?vue&type=style&index=0&id=40098b80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40098b80",
  null
  
)

export default component.exports